module.exports = __webpack_public_path__ + "img/print_handprint.617d30c.webp";